// src/features/password_reset/model/actions.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { authAPI } from "../../auth/api";
import { thunkHandlers } from "../../../store/thunkHandlers";
import { setMessage } from "../../messages/model/slice";
import { MESSAGE_SEVERITY } from "../../../utils/const";
import {IForgotPasswordData, IResetPasswordData} from "../../../models/iAuth";

export const fetchForgotPassword = createAsyncThunk(
    "passwordReset/forgot",
    async (data: IForgotPasswordData, { dispatch, rejectWithValue }) => {
        try {
            const result = await authAPI.forgotPassword(data);
            dispatch(setMessage({
                severity: MESSAGE_SEVERITY.success,
                text: "Код отправлен на вашу почту",
            }));
            return { email: data.email, resend_after: result.resend_after };
        } catch (e) {
            return rejectWithValue(thunkHandlers.error(e, dispatch));
        }
    },
);

export const fetchResetPassword = createAsyncThunk(
    "passwordReset/reset",
    async (data: IResetPasswordData, { dispatch, rejectWithValue }) => {
        try {
            const result = await authAPI.resetPassword(data);
            dispatch(setMessage({
                severity: MESSAGE_SEVERITY.success,
                text: result.message ?? "Пароль успешно изменён",
            }));
            return result;
        } catch (e) {
            return rejectWithValue(thunkHandlers.error(e, dispatch));
        }
    },
);